"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NET_DRIVE_RESULT_DRIVE_MODES = exports.NetDriveResultDriveMode = void 0;
exports.isNetDriveResultDriveMode = isNetDriveResultDriveMode;
var NetDriveResultDriveMode;
(function (NetDriveResultDriveMode) {
    NetDriveResultDriveMode["ACTIVE"] = "active";
    NetDriveResultDriveMode["INACTIVE"] = "inactive";
    NetDriveResultDriveMode["UNRESOLVED"] = "unresolved";
})(NetDriveResultDriveMode || (exports.NetDriveResultDriveMode = NetDriveResultDriveMode = {}));
function isNetDriveResultDriveMode(value) {
    return Object.values(NetDriveResultDriveMode).includes(value);
}
exports.NET_DRIVE_RESULT_DRIVE_MODES = Object.values(NetDriveResultDriveMode);
//# sourceMappingURL=net-drive-result-drive-mode.js.map